// extracted by mini-css-extract-plugin
module.exports = {"tableData":"TableData-module--tableData--18kd0"};